import { useEffect } from "react";
import WaterSystemSummaryTable from './WaterSystemSummaryTable';
import { useWaterSystemSearchModal } from "../reuseableComponents/WaterSystemSearchModalContext";

const WaterSystemDetailedInfoPage = () => {
  const selectedWaterSystem = JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
  const { setShowSystemSelectModal } = useWaterSystemSearchModal();

  useEffect(() => {
    // If selectedWaterSystem is not populated, open the modal
    if (!selectedWaterSystem || Object.keys(selectedWaterSystem).length === 0) {
      setShowSystemSelectModal(true);
    }
  }, [setShowSystemSelectModal, selectedWaterSystem]);

  return (
    <div className="water-system-summary">
      <h4>Detailed Info</h4>
      <br />
      {selectedWaterSystem && Object.keys(selectedWaterSystem).length > 0 && (
        <WaterSystemSummaryTable selectedWaterSystem={selectedWaterSystem} />
      )}
    </div>
  );
}
export default WaterSystemDetailedInfoPage;